import { useSyncExternalStore } from 'react';

import {
  isExportDownloadInFlight,
  subscribeToExportDownloadsInFlight,
} from '../api/downloadExport';

/**
 * Whether the export download with this key is currently in flight — true even
 * after the download modal is closed (the fetch keeps running in the background).
 * Drives the Download button's disabled state + tooltip.
 */
export const useExportDownloadInFlight = (key: string): boolean =>
  useSyncExternalStore(subscribeToExportDownloadsInFlight, () => isExportDownloadInFlight(key));
